import { NavLink } from 'react-router-dom';
import { Menu } from 'semantic-ui-react';
import styled from 'styled-components';

const MenuContainer = styled.div`
	margin: 1px 0px;
`;

const CustomMenu = styled(Menu)`
	background: #f2f3f3 !important;
`;

function TopNav() {
	return (
		<MenuContainer>
			<CustomMenu>
				<Menu.Item
					name="Test Runs"
					as={NavLink}
					to="/runs"
				/>

				<Menu.Item
					as={NavLink}
					to="/suites"
				>Spec History</Menu.Item>

				<Menu.Item
					name="Reports"
					as={NavLink}
					to="/reports"
				/>
{/*
				<Menu.Item
					name="Retry Flaky Probability"
					as={NavLink}
					to="/retries"
				/>

				<Menu.Item
					name="High Test Retries"
					as={NavLink}
					to="/retries"
				/>

				<Menu.Item
					name="Graphs"
					as={NavLink}
					to="/retries"
				/>

				<Menu.Item
					name="Barns"
					as={NavLink}
					to="/barns"
				/> */}
			</CustomMenu>
		</MenuContainer>
	);
}

export default TopNav;
